<template>
    <div :class="[ 'app-avatar', { 'hide-overflow': hasImage } ]" :style="style" :colored="isColored">
        <span class="lock" v-if="locked"><i class="fas fa-lock"></i></span>
        <img :src="image" v-if="hasImage">
        <span class="initials" v-else>{{ appInitials }}</span>
        <span class="before">{{ appInitials[0] }}</span>
        <span class="after">{{ appInitials[1] }}</span>
    </div>
</template>

<script>
export default {
    name: "app-avatar",
    props: {
        image: {
            required: false,
            type: String,
            default: ""
        },
        name: {
            required: true,
            type: String
        },
        color: {
            required: false,
            type: String,
            default: '#CCC'
        },
        isColored: {
            required: false,
            type: Boolean,
            default: false
        },
        locked: {
            required: false,
            type: Boolean,
            default: false,
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.name = this.name.trim();
        }
    },
    computed: {
        hasImage() {
            return this.image && this.image.length;
        },
        appInitials() {
            if(!this.name.length)
                return "..";

            let strArray = this.name.split(" ");
            if(strArray.length === 1)
                return strArray[0][0].toUpperCase();
            
            return `${strArray[0][0].toUpperCase()}${strArray[1][0].toUpperCase()}`;
        },
        style() {
            return this.isColored
                ? `background-color: ${this.color}; background: linear-gradient(102.2deg, ${this.color} 9.6%, #${this.lightenHex(this.color, 18)} 96.1%);`
                : "";
        }
    }
}
</script>

<style lang="scss" scoped>
.app-avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    background-color: $gray;
    img {
        width: 100%;
        max-height: 100%;
    }
    .initials {
        font-size: 10px;
        font-family: $montserrat;
        font-weight: 700;
        color: $dark-gray;
    }
    .lock {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: -5px;
        right: -5px;
        width: 22px;
        height: 22px;
        font-size: 10px;
        background-color: $light-red;
        color: $white;
        border-radius: 50%;
    }
    &.hide-overflow {
        overflow: hidden;
    }
    .before, .after {
        display: none;
    }
}

.dark {
    .app-avatar {
        background-color: $darkest-gray;
        .initials {
            color: $darker-gray;
        }
    }
}
</style>
